import './DialogContent.scss';

import React from 'react';

import { getBem } from '~/@sochi-components/@bem';

type DialogContentProps = {
    className?: string;
    children: React.ReactNode;
};

export class DialogContent extends React.PureComponent<DialogContentProps> {
    bem = getBem(this);

    render() {
        return <div className={this.bem.className}>{this.props.children}</div>;
    }
}
